import { Component } from 'react';
import BootstrapModal from 'react-bootstrap/lib/Modal';
import PropTypes from 'prop-types';
import { flow, toPairs, forEach } from 'lodash/fp';
import ModalDialog from './ModalDialog';

class Modal extends Component {
  static propTypes = {
    onHide: PropTypes.func,
  };

  // Legacy context: react-bootstrap 0.31's Modal.Header reads $bs_modal from
  // it (childContextTypes is copied from BootstrapModal below). It can only go
  // with a react-bootstrap upgrade.
  getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide,
      },
    };
  }

  render() {
    return (
      <BootstrapModal {...this.props} dialogComponentClass={ModalDialog} />
    );
  }
}
// assign Bootstrap Props
flow(
  toPairs,
  forEach(([prop, value]) => {
    Modal[prop] = value;
  }),
)(BootstrapModal);

export default Modal;
